import LogsService from '../services/logs.services';
import { RequestsLog } from '../types/RequestLog';
import { Metadata } from '../utils/HttpClientHandler';

const JobController = class JobController {
    public async getAllRequestLogs(filters = {}): Promise<{ data: RequestsLog[]; _metadata: Metadata }> {
        return LogsService.getAllRequestLogs(filters);
    }
};

export default new JobController();
